import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskLegacyAutomationRedirectCopyRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-automation-redirect-copy',
	path: '/projects/:projectKey/settings/automation/copy/:ruleId',
};
